export const complements_index = ['complements.index']
export const complements_create = ['complements.create']
export const complements_edit = ['complements.edit']

export default [].concat(
    complements_index,
    complements_create,
    complements_edit
)
